<template>
  <joint-event-container>
    <template #joint-content>
      <div class="joint-event-container md-layout">
        <div class="kabs-bg-image">
          <div class="kabs-content">
            <div class="md-layout contact-headline">
              <div class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-30 md-xsmall-size-100">
                <img
                  alt="kab logo"
                  class="kab-logo"
                  :src="require('../assets/bn-w@2x.png')"
                  @click="goToLogin"
                >
              </div>
            </div>
            <div>
              <slot name="content" />
            </div>
          </div>
          <Footer :accent="true" />
        </div>
      </div>
    </template>
  </joint-event-container>
</template>

<script>
import JointEventContainer from "@/components/JointEventContainer"
import Footer from "@/components/Footer"
import { mapGetters, mapState } from 'vuex'
export default {
  name: "KabJoin",
  components: {
    JointEventContainer,
    Footer
  },
  methods: {
    goToLogin() {
      this.$router.push('/welcome')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.joint-event-container {
  width: 100%;
  h1 {
    font-size: 66px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 36px;
  }

  .kabs-bg-image {
    width: 100%;
    background: url('~@/assets/bitmap.jpg');
    background-size: cover;
  }
  .kabs-content {
    margin: auto 14% auto 14%;
    min-height: 100vh;
  }
  .kab-logo {
    cursor: pointer;
  }
  .contact-headline {
    margin-top: 29px;
    text-align: left;
    h1 {
      margin: 0;
      font-size: 50px;
      font-weight: bold;
      line-height: 1.28;
      color: #000000;
    }
    p {
      font-size: 16px;
      line-height: 1.5;
      color: #000000;
    }
  }
}
@media only screen and (max-width: 600px) {
  .contact-container {
    h1 {
      font-size: 40px !important;
      margin-top: 30px !important;
    }
    .kabs-content {
      margin: auto 10% 25px 10%;
    }
  }
}
</style>
